import React from "react";

function formatNumber(val, precision) {
  return val.toFixed(precision);
}

function CustomLabel({
  x,
  y,
  width,
  height,
  value,
  prefix = "",
  suffix = "",
  precision = 1,
  layout = "horizontal",
  xOffset = 30
}) {
  const xxOffset =
    layout === "horizontal"
      ? x + width / 2
      : value < 0
      ? x + width - xOffset
      : x + width + xOffset;
  const yOffset =
    layout === "vertical" ? y + height / 2 : value < 0 ? y + 10 : y - 10;
  const className = value < 0 ? "red" : null;
  const val = `${prefix}${formatNumber(value, precision)}${suffix}`;

  return (
    <text
      x={xxOffset}
      y={yOffset}
      className={className}
      textAnchor="middle"
      dominantBaseline="middle"
    >
      {val}
    </text>
  );
}

export default CustomLabel;



// WEBPACK FOOTER //
// ./src/components/analysis/custom-label.js